import React from 'react'
import I18nCRUD from '../components/I18nCRUD'
import {I18nType} from '../../../utils/types'
import {i18n}  from '../../../i18n'
import {PageHeader} from 'antd'

const DosageFormsPage = () => {
    return (
        <div>
            <PageHeader className='site-page-header-responsive' title={i18n.t('planner.dosageForms.title')} onBack={() => window.history.back()}>
                <I18nCRUD
                    type={I18nType.DOSAGE_FORMS}
                    newTitle={i18n.t('planner.dosageForms.new')}
                    failUpdate={i18n.t('planner.dosageForms.failUpdate')}
                    failGet={i18n.t('planner.dosageForms.failGet')}
                    deleteTitle={i18n.t('planner.dosageForms.delete')}
                />
            </PageHeader>
        </div>
    )
}

export default DosageFormsPage
